import { API_ORIGIN } from '@/config'

const DEFAULT_AVATAR = '/img/mine/user.svg'

export function isBrokenRemoteAvatar(url) {
  if (!url) return false
  return /zxbuk\.oss-cn-hongkong\.aliyuncs\.com/i.test(url)
}

export function isStoredDataUrl(url) {
  return typeof url === 'string' && /^data:image\//i.test(url)
}

export function resolveAvatarUrl(url) {
  if (!url || isBrokenRemoteAvatar(url) || isStoredDataUrl(url)) {
    return DEFAULT_AVATAR
  }
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/uploads/')) return `${API_ORIGIN}${url}`
  return url
}
